var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item_module"},[_c('div',[_c('div',{staticClass:"block"},[_c('el-carousel',{attrs:{"height":"319px"}},_vm._l((_vm.imgList),function(url){return _c('el-carousel-item',{key:_vm.item},[_c('img',{attrs:{"height":"319px","src":url}})])}),1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }